(function () {
  'use strict';
  var cfgEl = document.getElementById('pufa-quiz-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG || !CFG.enable) return;

  var root = document.getElementById('pufa-quiz-root');
  if (!root) return;

  var state = { recipient: null, gender: null, type: null, step: 0, lastTrigger: null };
  var els = {}; // cached nodes after build

  function esc(s){ var d=document.createElement('div'); d.textContent=(s==null?'':s); return d.innerHTML; }
  // Haptics (wizard parity): tick on option taps, win pattern on the result reveal.
  var lastBuzz = 0;
  function haptic(kind){
    if (!navigator.vibrate || document.hidden) return;
    if (performance.now() - lastBuzz < 40) return; lastBuzz = performance.now();
    try { navigator.vibrate(kind === 'win' ? [15, 40, 30] : 10); } catch (e) {}
  }
  function track(name, detail){
    if (!CFG.track) return;
    var full = (CFG.eventPrefix || 'pufa_quiz') + '_' + name;
    (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: full }, detail || {}));
    if (typeof window.gtag === 'function') { try { window.gtag('event', full, detail || {}); } catch (e) {} }
    if (typeof window.fbq === 'function') { try { window.fbq('trackCustom', full, detail || {}); } catch (e) {} }
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('pufa_quiz', Object.assign({ name: full }, detail || {})); } catch (e) {}
    document.dispatchEvent(new CustomEvent('pufa_quiz', { detail: Object.assign({ name: full }, detail || {}) }));
  }
  function navigate(url){
    if (CFG.navigate === false) { if (window.__pufaNav) window.__pufaNav(url); return; }
    hardClose();
    window.location.assign(url);
  }

  function build(){
    root.className = 'pufa-quiz';
    root.style.setProperty('--pq-accent', CFG.accent || '#c70d38');
    if (CFG.soft) root.style.setProperty('--pq-soft', CFG.soft);
    root.style.setProperty('--pq-backdrop', String(CFG.backdropOpacity != null ? CFG.backdropOpacity : 0.28));
    // Portal: re-attach to <body>. Theme sections may carry transform/filter styles
    // (scroll animations), which break position:fixed descendants — the backdrop then
    // doesn't cover the viewport and click-outside misses it.
    if (root.parentNode !== document.body) document.body.appendChild(root);
    root.innerHTML =
      '<div class="pufa-quiz__backdrop" data-pq-close></div>' +
      '<div class="pufa-quiz__sheet" role="dialog" aria-modal="true" aria-label="שאלון פופה">' +
        '<button class="pufa-quiz__grab" type="button" data-pq-grab data-pq-close aria-label="גרור או הקש לסגירה"></button>' +
        '<button class="pufa-quiz__close" type="button" data-pq-close aria-label="סגירה">✕</button>' +
        '<button class="pufa-quiz__back" data-pq-back aria-label="חזרה לשלב הקודם" hidden><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 6 15 12 9 18"/></svg></button>' +
        '<span class="pq-live" aria-live="polite" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)"></span>' +
        '<div class="pufa-quiz__body"></div>' +
      '</div>';
    els.sheet = root.querySelector('.pufa-quiz__sheet');
    els.body = root.querySelector('.pufa-quiz__body');
    els.back = root.querySelector('[data-pq-back]');
    els.live = root.querySelector('.pq-live');
    root.addEventListener('click', function (e) {
      // e.target === root covers the case where theme CSS hides the backdrop
      // (e.g. a global div:empty reset) — a click outside the sheet then lands
      // on the root itself and must still dismiss.
      if (e.target === root || e.target.closest('[data-pq-close]')) { close('backdrop'); }
    });
    els.back.addEventListener('click', function(){ goBack(); });
  }

  // Per-path copy (issue #15): the shared strings are gift-neutral plural, which
  // misaddresses a self-buyer ("לפנק את עצמי" then being spoken to as אתם/לכם).
  // s2q must stay gender-neutral in selfWoman/selfMan: it renders BEFORE gender is known.
  // Overrides win over the section settings; anything missing falls back to CFG,
  // so merchant-edited strings still apply wherever no branch variant exists.
  var COPY = {
    selfWoman: {
      s2q: 'מה הסטייל שלך? 💫',
      customTitle: 'בוחרת סטייל בעצמך',
      rScoopCta: 'יאללה, בואי נמלא סקופ 🍀',
      otherCustom: 'או הציצי בלאקי סקופ ←',
      otherScoop: 'או הציצי בקפסולות בהתאמה אישית ←',
      s3q: 'איך בא לך לקבל את ההפתעה? 🥰',
      customSub: 'את בוחרת צבע, סוג וסטייל, וכל הזמנה מקבלת קפסולות בונוס חינם 🎁',
      title: 'מצאנו לך את ההפתעה המושלמת! ✨',
      rCustomSub: 'קפסולות בהתאמה אישית: את בוחרת סטייל, ואנחנו מוסיפים קפסולות בונוס חינם 🎁',
      rCustomCta: 'יאללה, בואי נבחר סטייל ✨',
      rScoopSub: 'לאקי סקופ: הפתעה מלאה! מה שיוצא מהסקופ מגיע אלייך עד הבית 💝'
    },
    selfMan: {
      s2q: 'מה הסטייל שלך? 💫',
      customTitle: 'בוחר סטייל בעצמך',
      rScoopCta: 'יאללה, בוא נמלא סקופ 🍀',
      otherCustom: 'או הצץ בלאקי סקופ ←',
      otherScoop: 'או הצץ בקפסולות בהתאמה אישית ←',
      s3q: 'איך בא לך לקבל את ההפתעה? 🥰',
      customSub: 'אתה בוחר צבע, סוג וסטייל, וכל הזמנה מקבלת קפסולות בונוס חינם 🎁',
      title: 'מצאנו לך את ההפתעה המושלמת! ✨',
      rCustomSub: 'קפסולות בהתאמה אישית: אתה בוחר סטייל, ואנחנו מוסיפים קפסולות בונוס חינם 🎁',
      rCustomCta: 'יאללה, בוא נבחר סטייל ✨',
      rScoopSub: 'לאקי סקופ: הפתעה מלאה! מה שיוצא מהסקופ מגיע אליך עד הבית 💝'
    },
    gift: {
      s2q: 'איזה סטייל מתאים להם? 💫',
      s3q: 'איזו הפתעה נכין להם? 🥰',
      customSub: 'אתם בוחרים בשבילם צבע, סוג וסטייל, וכל הזמנה מקבלת קפסולות בונוס חינם 🎁',
      title: 'מצאנו את המתנה המושלמת! 🎁',
      rCustomSub: 'קפסולות בהתאמה אישית: בוחרים סטייל בשבילם, ואנחנו מוסיפים קפסולות בונוס חינם 🎁',
      rCustomCta: 'יאללה, בואו נבחר סטייל ✨',
      rScoopSub: 'לאקי סקופ: הפתעה מלאה! מה שיוצא מהסקופ מגיע אליהם עד הבית 💝',
      giftText: 'טיפ קטן 🥰 חבילה גדולה יותר = יותר וואו כשפותחים, והבונוס גדל ביחד איתה 🎁',
      giftTextScoop: 'טיפ קטן 🥰 סקופ גדול יותר = יותר תכשיטים, יותר וואו 🎁'
    }
  };
  function P(key){
    var g = state.recipient === 'gift' ? COPY.gift : (state.gender === 'man' ? COPY.selfMan : COPY.selfWoman);
    return g[key];
  }

  // Peel a leading emoji off an option label so it can render as an icon coin.
  // ES5-safe: "first letter/digit index" instead of unicode-property regex.
  function splitLead(label){
    label = label == null ? '' : String(label);
    var i = label.search(/[A-Za-z0-9֐-׿]/);
    if (i > 0) {
      var ico = label.slice(0, i).trim(), txt = label.slice(i).trim();
      // symmetric labels ("🎁 מתנה 🎁"): drop the trailing twin so the coin isn't doubled
      if (ico && txt.slice(-ico.length) === ico) txt = txt.slice(0, -ico.length).trim();
      return { ico: ico, txt: txt };
    }
    return { ico: '', txt: label };
  }
  var TILE_SUB = { woman: 'שרשראות, צמידים, טבעות ועגילים', man: 'שרשראות, צמידים וטבעות' };
  function optBtn(label, val, hot){
    var p = splitLead(label);
    return '<button class="pufa-quiz__opt' + (hot ? ' pufa-quiz__opt--hot' : '') + '" data-pq-val="' + esc(val) + '">' +
      (p.ico ? '<span class="pq-ico" aria-hidden="true">' + esc(p.ico) + '</span>' : '') +
      '<span class="pq-lbl">' + esc(p.txt) + (TILE_SUB[val] ? '<span class="pq-tsub">' + esc(TILE_SUB[val]) + '</span>' : '') + '</span></button>';
  }
  // Step-3 product cards carry a full-height product photo flush to the card's
  // visual-left edge (RTL end) - the "Lucky Scoop list card" treatment.
  var CARD_IMG = {
    customWoman: 'https://pufa.co.il/cdn/shop/files/CustomCapsuleWomen.webp?v=1784235745&width=440',
    customMan: 'https://pufa.co.il/cdn/shop/files/CustomCapsuleMen.webp?v=1784235684&width=440',
    scoopWoman: 'https://pufa.co.il/cdn/shop/files/LuckyScoopWomen.webp?v=1784235761&width=440',
    scoopMan: 'https://pufa.co.il/cdn/shop/files/LuckyScoopMen.webp?v=1784235709&width=440'
  };
  function bigOpt(val, tagCls, tagTxt, ttl, sub, hot, img){
    var p = splitLead(ttl);
    return '<button class="pufa-quiz__opt pufa-quiz__opt--big' + (hot ? ' pufa-quiz__opt--hot' : '') + '" data-pq-val="' + esc(val) + '">' +
      (img ? '<span class="pq-media" aria-hidden="true"><img src="' + esc(img) + '" alt="" loading="lazy" draggable="false"></span>' : '') +
      '<span class="' + tagCls + '">' + esc(tagTxt) + '</span>' +
      '<span class="pq-txt"><span class="pq-ttl">' + esc(p.txt) + '</span>' +
      '<span class="pq-sub">' + esc(sub) + '</span></span></button>';
  }
  // Segmented progress beads with the gacha fill-ball inline at the row's end -
  // the exact device the order wizard uses (owner picked this one for both).
  // The step number lives in the live region for screen readers.
  // The ball's shown fill lags one step while a chunk is in flight - the chunk
  // "delivers" the new level on arrival; back-nav and no-chunk paths sync instantly.
  var ballPct = 0, chunkPending = false;
  function progress(n){
    var target = Math.round(n / 3 * 100);
    if (target <= ballPct || !chunkPending) ballPct = target;
    chunkPending = false;
    var segs = '';
    for (var i = 1; i <= 3; i++) segs += '<span class="pufa-quiz__seg' + (i < n ? ' is-done' : (i === n ? ' is-cur is-done' : '')) + '"></span>';
    return '<div class="pufa-quiz__progress" aria-hidden="true">' + segs +
      '<span class="pq-capfill" data-pq-target="' + target + '" style="--pq-fillpct:' + ballPct + '%"></span></div>';
  }
  // Direction-aware step entry + screen-reader announcement after each render.
  var navDir = 'fwd';
  function stepIn(announceTxt){
    els.body.style.setProperty('--pq-enter-x', navDir === 'back' ? '18px' : '-18px');
    navDir = 'fwd';
    els.body.classList.remove('pq-anim'); void els.body.offsetWidth; els.body.classList.add('pq-anim');
    if (els.live && announceTxt) { els.live.textContent = ''; requestAnimationFrame(function(){ els.live.textContent = announceTxt; }); }
    // one soft emoji burst on entry feedback is handled per option tap (see bindVals)
  }

  function renderStep1(){
    state.step = 1; els.back.hidden = true;
    var s = CFG.s1 || {};
    var html = progress(1) + '<h2 class="pufa-quiz__q">' + esc(s.q) + '</h2>' +
      '<div class="pufa-quiz__tiles">' + optBtn(s.self, 'self', false) + optBtn(s.gift, 'gift', false) + '</div>';
    if (CFG.showEvent && s.event)
      html += '<button class="pufa-quiz__opt pufa-quiz__opt--party" data-pq-val="event">' + esc(s.event) + '</button>';
    if (CFG.showSkip) html += '<button class="pufa-quiz__skip" data-pq-skip>' + esc(s.skip) + '</button>';
    els.body.innerHTML = html;
    bindVals(function(v){
      state.recipient = v; track('step', { step:1, q:'recipient', answer:v });
      if (v === 'event') renderParty(); else renderStep2();
    });
    var sk = els.body.querySelector('[data-pq-skip]');
    if (sk) sk.addEventListener('click', function(){ track('skip', { step:1 }); navigate(withRef(CFG.skipUrl)); });
    stepIn('שלב 1 מתוך 3: ' + (s.q || ''));
    focusFirst();
  }
  // Event organizers short-circuit straight to the Party Kit — gender/type don't apply.
  function renderParty(){
    els.back.hidden = true;
    var r = CFG.result || {};
    var dest = withRef((CFG.routing && CFG.routing.event) || CFG.skipUrl || '/');
    track('party', { destination: dest });
    if (!r.enable) { navigate(dest); return; }
    var html = '<div class="pufa-quiz__result"><div class="pufa-quiz__pop">🎉🎁</div>' +
      '<h2 class="pufa-quiz__q">' + esc(r.title) + '</h2>' +
      '<p class="pq-sub" style="font-size:13px;color:#7a6a62;margin:0 8px 14px">' + esc(r.partySub) + '</p>' +
      '<button class="pufa-quiz__cta" data-pq-go>' + esc(r.partyCta) + '</button>' +
      '<button class="pufa-quiz__other" data-pq-party-back>' + esc(r.partyBack) + '</button></div>';
    els.body.innerHTML = html;
    try {
      var ppop = els.body.querySelector('.pufa-quiz__pop');
      if (ppop && window.PufaEmoji && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        window.PufaEmoji.burst(ppop.getBoundingClientRect(), { count: 10, glyphs: ['🎉','🎁','✨'], spread: 'center', size: 18, life: 1000, dur: 900 });
      }
    } catch (e) {}
    els.body.querySelector('[data-pq-go]').addEventListener('click', function(){ track('result_cta', { type: 'party', destination: dest }); navigate(dest); });
    els.body.querySelector('[data-pq-party-back]').addEventListener('click', function(){
      state.recipient = null; track('party_back', {}); renderStep1();
    });
    focusFirst();
  }
  function renderStep2(){
    state.step = 2; els.back.hidden = false;
    var s = CFG.s2 || {};
    els.body.innerHTML = progress(2) + '<h2 class="pufa-quiz__q">' + esc(P('s2q') || s.q) + '</h2>' +
      '<div class="pufa-quiz__tiles">' + optBtn(s.woman, 'woman', false) + optBtn(s.man, 'man', false) + '</div>';
    bindVals(function(v){ state.gender = v; track('step', { step:2, q:'gender', answer:v }); renderStep3(); });
    stepIn('שלב 2 מתוך 3: ' + (P('s2q') || s.q || ''));
    focusFirst();
  }
  function renderStep3(){
    state.step = 3; els.back.hidden = false;
    var s = CFG.s3 || {}, c = s.custom || {}, k = s.scoop || {};
    var customHot = (s.featured || 'custom') === 'custom';
    var g = state.gender === 'man' ? 'Man' : 'Woman';
    var customHtml = bigOpt('custom','pufa-quiz__ribbon', c.ribbon, P('customTitle') || c.title, P('customSub') || c.sub, customHot, CARD_IMG['custom' + g]);
    var scoopHtml  = bigOpt('scoop','pufa-quiz__badge', k.badge, k.title, k.sub, !customHot, CARD_IMG['scoop' + g]);
    var order = customHot ? customHtml + scoopHtml : scoopHtml + customHtml;
    els.body.innerHTML = progress(3) + '<h2 class="pufa-quiz__q">' + esc(P('s3q') || s.q) + '</h2>' + order;
    bindVals(function(v){ state.type = v; track('step', { step:3, q:'type', answer:v }); finish(); });
    stepIn('שלב 3 מתוך 3: ' + (P('s3q') || s.q || ''));
    focusFirst();
  }

  function destination(){
    var key = state.gender + (state.type === 'custom' ? 'Custom' : 'Scoop');
    var url = (CFG.routing && CFG.routing[key]) || CFG.skipUrl || '/';
    return withRef(url);
  }
  function withRef(url){
    if (!url) return '/';
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return url + sep + 'ref=quiz&recipient=' + encodeURIComponent(state.recipient || '');
  }

  function finish(){
    var dest = destination();
    track('complete', { recipient:state.recipient, gender:state.gender, type:state.type, destination:dest });
    var r = CFG.result || {};
    if (!r.enable) { navigate(dest); return; }
    state.step = 4; els.back.hidden = false;
    var isCustom = state.type === 'custom';
    var sub = isCustom ? (P('rCustomSub') || r.customSub) : (P('rScoopSub') || r.scoopSub);
    var cta = isCustom ? (P('rCustomCta') || r.customCta) : (P('rScoopCta') || r.scoopCta);
    // shortcut: price + rating are literals, update here when the entry price or the Judge.me score changes
    var proof = isCustom ? (r.proofCustom || 'מ-₪40 לקפסולה · ⭐ 4.9 מתוך 5') : (r.proofScoop || 'מ-₪99 לסקופ · ⭐ 4.9 מתוך 5');
    // The reveal payoff: the capsule the shopper just FILLED drops in closed, cracks
    // open ~0.85s later, and the matched product springs out of it - the quiz's
    // anticipation loop finally pays off in-quiz instead of dumping straight to a sell.
    var revealImg = CARD_IMG[(isCustom ? 'custom' : 'scoop') + (state.gender === 'man' ? 'Man' : 'Woman')];
    // (the old "יש התאמה מושלמת!" chip was cut per owner review: it doubled the
    // title's message and crowded the reveal - the capsule IS the statement)
    var html = '<div class="pufa-quiz__result">' +
      '<div class="pq-reveal" aria-hidden="true"><img class="pq-reveal__img" src="' + esc(revealImg) + '" alt="" draggable="false"><span class="pq-reveal__cap"></span></div>' +
      '<h2 class="pufa-quiz__q">' + esc(P('title') || r.title) + '</h2>' +
      '<p class="pq-sub" style="font-size:13px;color:#7a6a62;margin:0 8px 10px">' + esc(sub) + '</p>' +
      '<p class="pq-proof">' + esc(proof) + '</p>';
    // Scoop has no bonus mechanic, so its gift nudge must not claim one —
    // separate per-path texts keep the stronger bonus line on Custom only.
    // The gift tip no longer re-asks "מתנה?" one step after the user answered it.
    var giftTxt = isCustom ? (P('giftText') || (CFG.gift && CFG.gift.text)) : (P('giftTextScoop') || (CFG.gift && (CFG.gift.textScoop || CFG.gift.text)));
    if (state.recipient === 'gift' && CFG.gift && CFG.gift.mode !== 'off' && giftTxt)
      html += '<div class="pufa-quiz__gift">' + esc(giftTxt) + '</div>';
    html += '<button class="pufa-quiz__cta" data-pq-go>' + esc(cta) + '</button>';
    if (r.showOther) html += '<button class="pufa-quiz__other" data-pq-other>' + esc(isCustom ? (P('otherCustom') || r.otherCustom) : (P('otherScoop') || r.otherScoop)) + '</button>';
    html += '</div>';
    els.body.innerHTML = html;
    // Two-beat win (wizard climax parity): the capsule drops in closed, then cracks
    // open with the product pop + haptic + burst. Reduced-motion: open instantly.
    var reveal = els.body.querySelector('.pq-reveal');
    var revealReduced = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (revealReduced || !reveal) {
      if (reveal) reveal.classList.add('is-open');
      haptic('win');
    } else {
      setTimeout(function(){
        if (!els.body.contains(reveal)) return; // user navigated away mid-beat
        reveal.classList.add('is-open');
        haptic('win');
        try {
          if (window.PufaEmoji) {
            window.PufaEmoji.burst(reveal.getBoundingClientRect(),
              { count: 14, glyphs: isCustom ? ['💎','✨','🎉','💝'] : ['🍀','✨','🎉','💝'], spread: 'center', size: 20, life: 1100, dur: 950 });
          }
        } catch (e) {}
      }, 850);
    }
    els.body.querySelector('[data-pq-go]').addEventListener('click', function(){ track('result_cta', { type: state.type, gender: state.gender, recipient: state.recipient, destination: dest, transport_type: 'beacon' }); navigate(dest); });
    var other = els.body.querySelector('[data-pq-other]');
    if (other) other.addEventListener('click', function(){
      state.type = isCustom ? 'scoop' : 'custom';
      track('result_other', { to: state.type });
      var d = destination(); navigate(d);
    });
    stepIn(P('title') || r.title || '');
    focusFirst();
  }

  function bindVals(cb){
    Array.prototype.forEach.call(els.body.querySelectorAll('[data-pq-val]'), function(btn){
      btn.addEventListener('click', function(){
        // selection thrill (wizard parity): tiny emoji burst from the tapped option,
        // plus the fill-chunk - a crimson bead fragment flies from the progress bar
        // into the gacha ball, which gulps it as its fill physically rises.
        haptic('tick');
        try {
          if (window.PufaEmoji && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
            window.PufaEmoji.burst(btn.getBoundingClientRect(), { count: 4, glyphs: ['✨','🎁','💫'], spread: 'center', size: 15, life: 700, dur: 600 });
            var bead = els.body.querySelector('.pufa-quiz__seg.is-cur');
            if (bead && window.PufaEmoji.flyTo) {
              // Wizard parity: a ghost of the tapped answer card lifts off, shrinks to
              // bead size and merges into the bead it just completed (live-tracked
              // across the step re-render); on landing the ball's fill rises.
              // target the bead that NEWLY fills from this answer (position-based fill
              // marks the current question's bead already); on the last answer the next
              // "bead" is the ball itself - the final piece lands in the capsule
              var beadIdx = Array.prototype.indexOf.call(bead.parentElement.children, bead) + 1;
              var beadNow = function(){ var p = els.body.querySelector('.pufa-quiz__progress'); return p ? p.children[beadIdx] : null; };
              chunkPending = true; // the next render keeps the old fill until the ghost lands
              window.PufaEmoji.flyTo(btn, beadNow, {
                ghost: true,
                onArrive: function(){
                  var b = beadNow();
                  if (b && b.animate) { try { b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.5)', offset: .4 }, { transform: 'scale(1)' }], { duration: 300, easing: 'ease-out' }); } catch (e3) {} }
                  var b2 = els.body.querySelector('.pq-capfill');
                  if (!b2) return;
                  var tg = parseInt(b2.getAttribute('data-pq-target'), 10) || 0;
                  b2.style.setProperty('--pq-fillpct', tg + '%'); ballPct = tg;
                }
              });
              // belt + braces: never leave the ball under-filled if the flight is lost
              setTimeout(function(){
                var b3 = els.body.querySelector('.pq-capfill');
                if (!b3) return;
                var tg2 = b3.getAttribute('data-pq-target');
                if (tg2 && b3.style.getPropertyValue('--pq-fillpct') !== tg2 + '%') {
                  b3.style.setProperty('--pq-fillpct', tg2 + '%'); ballPct = parseInt(tg2, 10) || ballPct;
                }
              }, 1500);
            }
          }
        } catch (e) {}
        cb(btn.getAttribute('data-pq-val'));
      });
    });
  }
  function focusFirst(){
    var f = els.body.querySelector('button');
    if (f) f.focus();
  }
  function goBack(){
    navDir = 'back';
    track('back', { from: state.step });
    if (state.step === 4) renderStep3();
    else if (state.step === 3) renderStep2();
    else if (state.step === 2) renderStep1();
  }

  // Entry-source for analytics: every trigger link shares the same href, so derive
  // WHERE it was clicked from the enclosing section id (hero vs mid-page card).
  function sourceOf(trigger, fallback){
    if (!trigger) return fallback || 'api';
    var sec = trigger.closest('.shopify-section');
    var sid = (sec && sec.id) || '';
    if (/hero/i.test(sid)) return 'hero';
    if (/button/i.test(sid)) return 'midpage';
    return sid || 'link';
  }
  function open(trigger, srcOverride){
    if (!els.sheet) build();
    state.recipient = state.gender = state.type = null;
    state.lastTrigger = trigger || null;
    renderStep1();
    root.classList.add('is-open');
    // Note: we intentionally do NOT lock <html> overflow — that hid the scrollbar
    // and caused a layout shift. The fixed overlay covers the page; the scrollbar stays.
    document.addEventListener('keydown', onKey);
    track('open', { source: srcOverride || sourceOf(trigger) });
  }
  function teardown(){
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
  }
  function close(method){
    teardown();
    track('dismiss', { step: state.step, method: method || 'close' });
    if (state.lastTrigger && state.lastTrigger.focus) state.lastTrigger.focus();
  }
  // Silent close (no tracking) — used right before navigating away and on bfcache
  // restore, so pressing Back never returns the user to a stale open modal.
  function hardClose(){ teardown(); }
  function onKey(e){
    if (e.key === 'Escape') { close('esc'); return; }
    if (e.key === 'Tab') trapFocus(e);
  }
  function trapFocus(e){
    var f = els.sheet.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length-1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // Swipe-to-dismiss on the grab handle / sheet (mobile). Wizard parity: a 10px
  // threshold so taps never nudge the sheet, is-dragging kills the transition so
  // the sheet tracks the finger 1:1, and preventDefault (non-passive) stops the
  // browser rubber-banding underneath an active drag.
  function bindSwipe(){
    var startY = null, dy = 0, dragging = false, DRAG_MIN = 10;
    root.addEventListener('touchstart', function(e){
      if (window.innerWidth >= 1024) return; // desktop = centered modal, no swipe
      if (!e.target.closest('[data-pq-grab]') && !e.target.closest('.pufa-quiz__sheet')) return;
      if (els.sheet.scrollTop > 0) return;
      startY = e.touches[0].clientY; dy = 0; dragging = false;
    }, { passive: true });
    root.addEventListener('touchmove', function(e){
      if (startY === null) return;
      dy = e.touches[0].clientY - startY;
      if (!dragging) { if (dy < DRAG_MIN) return; dragging = true; els.sheet.classList.add('is-dragging'); }
      if (e.cancelable) e.preventDefault();
      if (dy > 0) els.sheet.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    root.addEventListener('touchend', function(){
      if (startY === null) return;
      if (dragging) { els.sheet.classList.remove('is-dragging'); els.sheet.style.transform = ''; if (dy > 110) close('swipe'); }
      startY = null; dy = 0; dragging = false;
    });
  }

  function bindTriggers(){
    var sel = CFG.trigger || '#pufa-quiz';
    var selector = 'a[href$="' + sel + '"], [data-pufa-quiz-open]';
    document.addEventListener('click', function(e){
      var t;
      // Guard against a malformed merchant-set trigger producing an invalid selector.
      try { t = e.target.closest(selector); }
      catch (err) { t = e.target.closest('[data-pufa-quiz-open]'); }
      if (!t) return;
      e.preventDefault();
      open(t);
    });
  }

  build();
  bindSwipe();
  bindTriggers();
  // Arriving from another page via a /#pufa-quiz link: open the quiz on load, then
  // strip the hash so Back/reload (esp. non-bfcache WebViews) can't re-pop it.
  if (location.hash === '#pufa-quiz') {
    setTimeout(function(){
      open(null, 'hash');
      try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {}
    }, 150);
  }
  // If the page is restored from the back/forward cache (user pressed Back after we
  // sent them to the product), force the modal closed so it isn't stuck open.
  window.addEventListener('pageshow', function(e){ if (e.persisted) hardClose(); });
  window.PufaQuiz = { open: function(){ open(null); }, close: close };
})();
